<template>
  <div>
    <v-dialog
      v-model="value"
      persistent
      max-width="900px"
      scrollable
    >
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">{{ title }} </span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex
                order-xs2
                order-md2
                xs12
                md6
              >
                <v-layout 
                  wrap 
                  row
                >
                  <v-flex 
                    xs12
                    md6
                  >
                    <v-text-field
                      :error-messages="nameErrors"
                      v-model="$v.userForm.firstName.$model"
                      label="Nombre(s)"
                      required
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    md6
                  >
                    <v-text-field
                      :error-messages="lastNameErrors"
                      v-model="$v.userForm.lastName.$model"
                      label="Apellido paterno"
                    />
                  </v-flex>
                </v-layout>
                <v-layout 
                  wrap 
                  row
                >
                  <v-flex
                    xs12
                    md6
                  >
                    <v-text-field
                      :error-messages="maternalSurnameErrors"
                      v-model="$v.userForm.maternalSurname.$model"
                      label="Apellido materno"
                    />
                  </v-flex>
                  <v-flex 
                    xs12
                    md6
                  >
                    <v-text-field
                      :error-messages="phoneErrors"
                      v-model="$v.userForm.phone.$model"
                      label="Teléfono"
                      required
                      type="number"
                    />
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex 
                    xs12
                    md6
                  >
                    <v-text-field
                      :error-messages="postalError"
                      v-model="$v.userForm.zipCode.$model"
                      label="Código postal"
                      required
                      type="number"
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    md6
                  >
                    <v-text-field
                      :error-messages="suburbError"
                      v-model="$v.userForm.suburb.$model"
                      label="Colonia"
                    />
                  </v-flex>
                </v-layout>
                <v-layout 
                  wrap 
                  row
                >
                  <v-flex 
                    xs12
                    md6
                  >
                    <v-text-field
                      :error-messages="cityErrors"
                      v-model="$v.userForm.city.$model"
                      label="Municipio"
                      required
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    md6
                  >
                    <v-text-field
                      :error-messages="stateErrors"
                      v-model="$v.userForm.state.$model"
                      label="Estado"
                    />
                  </v-flex>
                </v-layout>
                <v-layout 
                  wrap 
                  row
                >
                  <v-flex 
                    xs12
                    md6
                  >
                    <v-text-field
                      :error-messages="streetErrors"
                      v-model="$v.userForm.street.$model"
                      label="Calle"
                      required
                    />
                  </v-flex>
                  <v-flex 
                    xs12
                    md6
                  >
                    <v-text-field
                      :error-messages="extNumberErrors"
                      v-model="$v.userForm.extNumber.$model"
                      label="Numero exterior"
                      required
                    />
                  </v-flex>
                </v-layout>
                <v-layout 
                  wrap 
                  row
                >
                  <v-flex
                    xs12
                    md6
                  >
                    <v-text-field
                      v-model="$v.userForm.reference.$model"
                      label="Referencias"
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    md6
                  >
                    <v-text-field
                      :error-messages="tenencyErrors"
                      v-model="$v.userForm.tenantry.$model"
                      label="Tenencia"
                    />
                  </v-flex>
                </v-layout>
                <v-layout>
                  <!-- <v-flex 
                    xs12
                    md6
                  >
                    <v-text-field
                      v-model="$v.userForm.impairment.$model"
                      label="Impedimentos físicos"
                      required
                    />
                  </v-flex> -->
                  <v-flex 
                    xs12
                  >
                    <v-text-field
                      v-model="$v.userForm.medicalNotes.$model"
                      label="Notas médicas"
                      required
                    />
                  </v-flex>
                </v-layout>
                <v-layout 
                  wrap 
                  row
                >
                  <v-flex
                    xs12
                    md6
                  >
                    <v-text-field
                      v-model="$v.userForm.socialContacts.$model"
                      label="Red social (Facebook)"
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    md6
                  >
                    <v-text-field
                      v-model="$v.userForm.familyResponsible.$model"
                      label="Familiar responsable"
                    />
                  </v-flex>
                </v-layout>
                <v-layout 
                  wrap 
                  row
                >
                  <!-- <v-flex 
                    xs12
                    md6
                  >
                    <v-text-field
                      :error-messages="nameErrors"
                      v-model="$v.userForm.location.$model"
                      label="Unicación"
                      required
                    />
                  </v-flex> -->
                  <!-- <v-flex 
                    xs12
                    md6
                  >
                    <v-text-field
                      :error-messages="phoneErrors"
                      v-model="$v.userForm.phone.$model"
                      label="Teléfono"
                      required
                      type="number"
                    />
                  </v-flex> -->
                  <v-flex
                    xs12
                  >
                    <v-text-field
                      :error-messages="emailErrors"
                      v-model="$v.userForm.email.$model"
                      label="Correo electrónico"
                    />
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs12>
                    <v-text-field
                      :error-messages="personIdErrors"
                      v-model="$v.userForm.personId.$model"
                      label="CURP"
                    />
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <v-checkbox
                      color="primary"
                      v-model="impairmentStatus"
                      @change="userForm.impairment = ''"
                      style="display: inline-block"
                    >
                      <template v-slot:label>
                        ¿Presanta incapacidades físicas? 
                      </template>
                    </v-checkbox>
                  </v-flex>
                </v-layout>
                <v-layout
                  v-if="impairmentStatus"
                >
                  <v-flex>
                    <v-text-field
                      label="Descripción"
                      v-model="$v.userForm.impairment.$model"
                      outline
                    />
                  </v-flex>
                </v-layout>

                <v-layout
                  wrap
                  row
                >
                  <v-flex
                    xs12
                  >
                    <v-radio-group
                      v-model="$v.userForm.gender.$model"
                      color="primary"
                      :error-messages="genderErrors"
                    >
                      <v-radio
                        color="primary"
                        label="Masculino"
                        value="MALE"
                      />
                      <v-radio
                        color="primary"
                        label="Femenino"
                        value="FEMALE"
                      />
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex
                order-xs1
                order-md2
                xs8
                offset-xs2
                md6
                offset-md0
              >
                <v-layout
                  align-center
                  justify-center
                  row
                  fill-height
                  wrap
                  @mouseover="flags.updateImage = true"
                  @mouseleave="flags.updateImage = false"
                >
                  <v-flex
                    style="text-align: center;"
                    sm7
                    v-show="working.wImage"
                  >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    />
                  </v-flex>
                  <v-flex
                    v-show="!working.wImage"
                    xs7
                    style="border-radius: 50%;"
                    id="parentContainerEmployeeImage"
                    :class="!flags.changed && (!student || !student.imageStorage || !student.imageStorage.miniObjUrl ? 'gradiente' : '')"
                  >
                    <label id="img_edit_employee_default">
                      <v-img
                        v-if="!student || !student.imageStorage || !student.imageStorage.miniObjUrl"
                        :src="require('@/assets/panel/modals/AddPhotoIcon@3x.png')"
                      />
                      <v-img
                        style="border-radius: 50%; text-align:center;"
                        v-else
                        :src="student.imageStorage.miniObjUrl"
                      />
                    </label>
                    <label
                      style="display: none; text-align: center;"
                      id="img_edit_employee"
                    />

                    <!-- <input
											type="file"
											id="edit_logo"
											name="edit_logo"
											accept="image/*"
											style="display: none;"
											@change="processImage($event)"
                    >-->
                  </v-flex>
                  <br>
                  <v-flex xs7>
                    <v-expand-transition>
                      <v-btn
                        block
                        class="gradiente"
                        style="border-radius: 33px;"
                        v-show="flags.updateImage"
                        dark
                        @click="modals.image = true"
                      >
                        Actualizar
                      </v-btn>
                    </v-expand-transition>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="working.wUpdate"
            flat
            @click="close"
          >
            Cancelar
          </v-btn>
          <v-btn
            :disabled="working.wUpdate"
            color="primary darken-1"
            flat
            @click="submit"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loading
      v-model="working.wUpdate"
      text="Trabajando..."
    />
    <success
      v-if="student != null"
      v-model="toast.success"
      text="Creación Exitosa"
    />
    <success
      v-else
      v-model="toast.success"
      text="Actualización Exitosa"
    />
    <error
      v-model="toast.failed"
      :text="toast.fmessage"
    />
    <editImage
      :title="(userForm.image != null) ? 'Editar imagen' : 'Añadir imagen'"
      @loaded="processImage($event)"
      v-model="modals.image"
    />
    <alert
      v-model="alertModal.show"
      title="Aviso"
      :description="alertModal.message"
    />
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import loading from "../../Dialogs/Loading.vue";
import success from "../../Dialogs/Success.vue";
import error from "../../Dialogs/Error.vue";
import editImage from "../EditImage.vue";
import alert from "../../../components/Dialogs/Alert.vue"

import { isEmptyOrNull, getLevelGGIds } from '../../../plugins/GeneralMethods';
export default {
  props: ["title", "parent", "value", "student", "branch"],
  components: {
    loading,
    success,
    error,
    editImage,
    alert
  },
  validations: {
    userForm: {
      firstName: { required },
      lastName: { required },
      maternalSurname: { required },
      gender: { required },
      personId: { required },
      level: {  },
      gg: {  },
      qrEnabled: {},
      zipCode: {},
      suburb: {},
      city: {},
      state: {},
      street: {},
      number: {},
      extNumber: {},
      email: {email},
      socialContacts: {},
      location: {},
      phone: {},
      medicalNotes: {},
      familyResponsible: {},
      tenantry: {  }, 
      reference: {},
      impairment: {}
    }
  },
  watch: {
    value() {
      this.getLevels();
    }
  },

  mounted() {},
  data: () => ({
    modals: {
      image: false
    },
    impairmentStatus: false,
    userForm: {
      firstName: "",
      lastName: "",
      maternalSurname: "",
      gender: "",
      personId: "",
      level: {},
      gg: {},
      qrEnabled: false,
      zipCode: "",
      suburb: "",
      city: "",
      state: "",
      street: "",
      number: "",
      extNumber: "",
      email: "",
      socialContacts: "",
      location: "",
      phone: "",
      medicalNotes: "",
      familyResponsible: "",
      tenantry: "", 
      reference: "",
      impairment: ""
    },
    userImg: null,
    working: {
      wUpdate: false,
      wImage: false
    },
    toast: {
      success: false,
      failed: false,
      fmessage: "Ups ocurrió un error"
    },
    alertModal: {
      show: false,
      message: ''
    },
    flags: {
      updateImage: false,
      changed: false
    },
    levels: [],
    ggs: [],
    selectedLevel: {},
    stdIdToAdd: {}
  }),
  methods: {
    text: item => item.grade + "" + item.group,
    setInfoToShowOnUpdate() {
      if (this.value) {
        if (this.student != null) {
          this.userForm.id = this.student.id;
          this.userForm.firstName = this.student.firstName;
          this.userForm.lastName = this.student.lastName;
          this.userForm.personId = this.student.personId;
          this.userForm.gender = this.student.gender;
          this.userForm.personId = this.student.personId;
          this.userForm.level = this.student.level;
          this.userForm.qrEnabled = this.student.qrEnabled;
          this.userForm.zipCode = this.student.zipCode; 
          this.userForm.suburb = this.student.suburb; 
          this.userForm.city = this.student.city; 
          this.userForm.state = this.student.state; 
          this.userForm.street = this.student.street; 
          this.userForm.number = this.student.number; 
          this.userForm.extNumber = this.student.extNumber; 
          this.userForm.email = this.student.email; 
          this.userForm.socialContacts = this.student.socialContacts; 
          this.userForm.location = this.student.location; 
          this.userForm.phone = this.student.phone; 
          this.userForm.medicalNotes = this.student.medicalNotes; 
          this.userForm.maternalSurname = this.student.maternalSurname
          this.userForm.tenantry = this.student.tenantry
          this.userForm.reference = this.student.reference
          this.userForm.impairment = this.student.impairment
          this.userForm.familyResponsible = this.student.familyResponsible
          if (!isEmptyOrNull(this.userForm.impairment)){
            this.impairmentStatus = true
          }else{
            this.impairmentStatus = false
          }
          for (var lvl in this.levels) {
            if (this.student.level.id == this.levels[lvl].id) {
              this.ggs = this.levels[lvl].ggs;
              this.$forceUpdate();
              break;
            }
          }
          this.userForm.gg = this.student.gg;
          if (
            this.student.image != null &&
            this.student.image != "" &&
            this.student.image != "data:image/jpeg;base64,undefined" &&
            this.student.image != "data:image/jpeg;base64," &&
            this.student.image != "data:image/jpeg;base64, "
          ) {
            this.processImage(this.student.image);
          }
        }else {
          this.$v.userForm.gender.$model = "MALE"
        }
      }else {
        this.$v.userForm.gender.$model = "MALE"
      }
    },
    getLevels() {
      this.setInfoToShowOnUpdate();
      // this.working.wUpdate = true;
      // this.$store
      //   .dispatch("tutor/getLevelsParentTool")
      //   .then(response => {
      //     this.levels = response.data.entity.levels;
      //     this.working.wUpdate = false;
      //     this.setInfoToShowOnUpdate();
      //   })
      //   .catch(error => {
      //     console.log(error);
      //     this.working.wUpdate = false;
      //     this.toast.failed = true;
      //   });
    },

    processImage(event) {
      this.working.wImage = true;
      this.userForm.image = event.split(",")[1];
      document.getElementById(
        "img_edit_employee"
      ).innerHTML = `<img class="elevation-4" src="${event}" style='width: 120px; height: 120px; object-fit: cover; border-radius: 50%;'>`;
      document.getElementById("img_edit_employee").style.display = "block";
      document.getElementById("img_edit_employee_default").style.display =
        "none";
      this.working.wImage = false;
      this.flags.changed = true;
    },
    submit() {
      this.$v.userForm.$touch();
      var levelGGData = getLevelGGIds(this.branch)
      if(isEmptyOrNull(levelGGData)){
        this.alertModal.show = true
        this.alertModal.message = "Por el momento no es posible agregar un alumno. Solicita al administrador que establezcan un grado y grupo por defecto"
        return
      }
      if (!this.$v.userForm.$invalid) {
        this.working.wUpdate = true;
        if (this.student == null) {
          var obj = this.userForm;
          obj.level = { id: levelGGData.idLevel}
          obj.gg = { id: levelGGData.idGG}
          obj.location = ""
          console.log(obj);
          this.$store
            .dispatch("workshop/createStudent", obj)
            .then(response => {
              this.stdIdToAdd = response.data.entity;

              if (this.parent != null) {
                this.$store
                  .dispatch("tutor/addChildToParent", {
                    pid: this.parent,
                    sid: this.stdIdToAdd.id
                  })
                  .then(res => {
                    this.working.wUpdate = false;
                    this.$v.$reset();
                    this.$emit("created", response.data.entity);
                    this.close();
                  })
                  .catch(error => {
                    this.working.wUpdate = false;
                    this.toast.failed = true;
                    if (error.status == 200) {
                      this.toast.fmessage = error.data.message;
                    }
                    console.log(error);
                  });
              } else {
                this.working.wUpdate = false;
                this.$emit("created", response.data.entity);
                this.close();
              }
            })
            .catch(error => {
              this.working.wUpdate = false;
              this.toast.failed = true;
              if (error.status == 200) {
                this.toast.fmessage = error.data.message;
              }
              console.log(error);
            });
        } else {
          var obj = this.userForm;

          this.$store
            .dispatch("workshop/updateStudent", obj)
            .then(response => {
              this.working.wUpdate = false;
              this.$v.$reset();
              this.toast.success = true;
              response.data.entity.image =
                "data:image/jpeg;base64," + response.data.entity.image;

              this.$emit("updated", response.data.entity);
              this.close();
            })
            .catch(error => {
              this.working.wUpdate = false;
              this.toast.failed = true;
              if (error.status == 200) {
                this.toast.fmessage = error.data.message;
              }
              console.log(error);
            });
        }
      }
    },
    close() {
      this.$v.$reset();
      document.getElementById("img_edit_employee").innerHTML = ``;
      document.getElementById("img_edit_employee").style.display = "none";
      document.getElementById("img_edit_employee_default").style.display =
        "block";
      this.flags.changed = false;

      this.userForm = {
        firstName: "",
        lastName: "",
        personId: "",
        maternalSurname: "",
        level: {},
        gg: {}
      };
      this.$emit("input", !this.value);
      this.$emit("onClosed", false);
    },
    filterGGsByLevel(val) {
      this.levels.filter(item => {
        if (item.id == val.id) {
          this.ggs = item.ggs;
          this.$forceUpdate();
        }
      });
    },
    handleKeyDown(e) { //method to handle the keypress
      if (e.code === "Escape") {
        this.close();
      }
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown); //will attach the event listener to the whole window when the component is created
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown); //will detach the event listener once the component is destroyed
  },

  computed: {
    levelErrors() {
      const errors = [];
      if (!this.$v.userForm.level.$dirty) return errors;
      !this.$v.userForm.level.required && errors.push("Nivel obligatorio");

      return errors;
    },
    ggErrors() {
      const errors = [];
      if (!this.$v.userForm.gg.$dirty) return errors;
      !this.$v.userForm.gg.required &&
        errors.push("Grado y grupo obligatorios");

      return errors;
    },

    personIdErrors() {
      const errors = [];
      if (!this.$v.userForm.personId.$dirty) return errors;
      !this.$v.userForm.personId.required &&
        errors.push("CURP obligatoria");

      return errors;
    },
    lastNameErrors() {
      const errors = [];
      if (!this.$v.userForm.lastName.$dirty) return errors;
      !this.$v.userForm.lastName.required &&
        errors.push("Apellido paterno obligatorio");

      return errors;
    },
    maternalSurnameErrors() {
      const errors = [];
      if (!this.$v.userForm.maternalSurname.$dirty) return errors;
      !this.$v.userForm.maternalSurname.required &&
        errors.push("Apellido materno obligatorio");
      return errors;
    },
    tenencyErrors(){
      const errors = [];
      if (!this.$v.userForm.tenantry.$dirty) return errors;
      if (!this.$v.userForm.tenantry.required) {
        return errors
      }
      errors.push("La tenencia es obligatoria ");
      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.userForm.firstName.$dirty) return errors;
      !this.$v.userForm.firstName.required && errors.push("Nombre obligatorio");
      return errors;
    },
    genderErrors() {
      const errors = [];
      if (!this.$v.userForm.gender.$dirty) return errors;
      !this.$v.userForm.gender.required && errors.push("Genero obligatorio");
      return errors;
    },
    suburbError() {
      const errors = [];
      if (!this.$v.userForm.suburb.$dirty) return errors;
      if (!this.$v.userForm.suburb.required) {
        return errors
      }
      !this.$v.userForm.suburb.required && errors.push("Colinia obligatoria");
      return errors;
    },
    cityErrors() {
      const errors = [];
      if (!this.$v.userForm.city.$dirty) return errors;
      if (!this.$v.userForm.city.required) {
        return errors
      }
      !this.$v.userForm.city.required && errors.push("Ciudad obligatoria");
      return errors;
    },
    stateErrors() {
      const errors = [];
      if (!this.$v.userForm.state.$dirty) return errors;
      if (!this.$v.userForm.state.required) {
        return errors
      }
      !this.$v.userForm.state.required && errors.push("Estado obligatorio");
      return errors;
    },
    streetErrors() {
      const errors = [];
      if (!this.$v.userForm.street.$dirty) return errors;
      if (!this.$v.userForm.street.required) {
        return errors
      }
      !this.$v.userForm.street.required && errors.push("Calle obligatoria");
      return errors;
    },
    extNumberErrors() {
      const errors = [];
      if (!this.$v.userForm.extNumber.$dirty) return errors;
      if (!this.$v.userForm.extNumber.required) {
        return errors
      }
      !this.$v.userForm.extNumber.required && errors.push("Número extero obligatorio");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.userForm.email.$dirty) return errors;
      if(!this.$v.userForm.email.required){
        return errors
      }
      if (!this.$v.userForm.email.email) {
        errors.push("Correo electrónico incorrecto");
        return errors;
      }
      return errors;
    },
    postalError() {
      const errors = [];
      if (!this.$v.userForm.zipCode.$dirty) return errors;
      if (!this.$v.userForm.zipCode.required) {
        return errors
      }
      errors.push("Código postal obligatorio");
      return errors;
    },
    phoneErrors() {
      const errors = [];
      if (!this.$v.userForm.phone.$dirty) return errors;
      if (!this.$v.userForm.phone.required) {
        return errors
      }
      errors.push("Teléfono obligatorio");
      return errors;
    }
  }
};
</script>

<style>
.no-properties {
  width: 0% !important;
  height: 0% !important;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
-webkit-appearance: none;
margin: 0;
}

/* Firefox */
input[type=number] {
-moz-appearance: textfield;
}
</style>
